module.exports = __webpack_public_path__ + "static/flags/WF-e831bc37dcf17188929da084d8f76197.gif";